import ajax from '../../lib/appfuse-react/core/ajax';

const candidateService = {
  post: async (props) => {
    const response = await ajax.post("expo/candidates", props);
    return response.data;
  },
  isCandidateExisted: async (primaryContactNumber, email) => {
    const response = await ajax.get(`expo/candidates/existed?phone=${primaryContactNumber}&email=${email}`);
    return response.data;
  },
  getStatistics: async (year) => {
    const response = await ajax.get(`expo/candidates/statistics`, {year});
    return response.data;
  },
  getGroupedStatistics: async (year, groupByPhone = false) => {
    const response = await ajax.get(`expo/candidates/statistics/grouped`, {year, groupByPhone});
    return response.data;
  },
}

export default candidateService;